import React from 'react';
import { useTranslation } from 'react-i18next';
import MediaPicker from '../MediaPicker';

/**
 * Step: pick the photos & videos for the screen (ordered multi-select).
 * `value` is an ordered array of media ids — selection order = play order.
 *
 * ⚠️ MARKUP PORTED FROM THE PROTOTYPE's stepPicker('media') — fc-p-t/fc-p-s.
 */
export default function MediaPickStep({ value = [], onChange }) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="fc-p-t">{t('cafe_wizard.step_media')}</div>
      <div className="fc-p-s">{t('cafe_wizard.media_step_subtitle')}</div>
      <MediaPicker family="visual" value={value} onChange={onChange} allowUpload />
    </div>
  );
}
